exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".offset-template {\n  position: relative;\n}\n.offset-template:before {\n  content: \" \";\n  display: inline-block;\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  background-color: #666;\n  left: -16px;\n}\n.v-card--material-title {\n  position: relative;\n}\n.v-card--material-title .v-offset {\n  display: inline-block;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1;\n          flex: 0 1;\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: auto;\n  margin-bottom: 0 !important;\n  padding: 0 16px 0;\n}", ""]);

// exports
